import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";
import i18n from "../locales/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { layout: "main", auth: true },
    component: Home,
  },
  {
    path: "/project/:project_id",
    name: "Project",
    meta: { layout: "main", auth: true },
    component: () => import("../views/Project.vue"),
    props: true,
    children: [
      {
        path: "task/:task_id",
        name: "TaskBody",
        meta: { layout: "main", auth: true },
        component: () => import("../views/TaskBody.vue"),
      },
    ],
  },
  {
    path: "/inbox/:project_id",
    name: "Inbox",
    meta: { layout: "main", auth: true },
    component: () => import("../views/Project.vue"),
    props: true,
    children: [
      {
        path: "task/:task_id",
        name: "InboxTaskBody",
        meta: { layout: "main", auth: true },
        component: () => import("../views/TaskBody.vue"),
      },
    ],
  },
  {
    path: "/chats/:chat_id",
    name: "Chats",
    meta: { layout: "main", auth: true },
    component: () => import("../views/Chats.vue"),
    props: true,
    children: [
      {
        path: "project/:project_id/task/:task_id",
        name: "TaskBodys",
        meta: { layout: "main", auth: true },
        component: () => import("../views/TaskBody.vue"),
      },
    ],
  },
  {
    path: "/search",
    name: "Search",
    meta: { layout: "main", auth: true },
    component: () => import("../components/tasks/Tasks.vue"),
  },
  {
    path: "/remove_list",
    name: "Remove",
    meta: { layout: "main", auth: true },
    component: () => import("../views/Remove.vue"),
  },
  {
    path: "/onboard",
    name: "Onboard",
    meta: { layout: "main", auth: true },
    component: () => import("../layouts/OnboardLayout.vue"),
  },
  {
    path: "/no-lists",
    name: "NoLists",
    meta: { layout: "main", auth: true },
    component: () => import("../views/NoLists.vue"),
  },
  {
    path: "/file/:file_id",
    name: "RouteFile",
    meta: { layout: "main", auth: true },
    component: () => import("../views/RouteFile.vue"),
  },
  {
    path: "/shortcuts/:shortcuts",
    name: "shortcuts",
    meta: { layout: "main", auth: true },
    component: () => import("../views/Shortcut.vue"),
    props: true,
    children: [
      {
        path: "project/:project_id",
        name: "Project_shortcuts",
        meta: { layout: "main", auth: true },
        component: () => import("../views/TaskBody.vue"),
        props: true,
        children: [
          {
            path: "task/:task_id",
            name: "TaskBody_shortcuts",
            meta: { layout: "main", auth: true },
            component: () => import("../views/TaskBody.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/todoist",
    name: "todoist",
    meta: { layout: "import", auth: true },
    component: () => import("../layouts/ImportLayout.vue"),
  },
  {
    path: "/microsoft",
    name: "microsoft",
    meta: { layout: "import", auth: true },
    component: () => import("../layouts/ImportLayout.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: { layout: "auth", auth: false },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/app_auth",
    name: "AppAuth",
    meta: { layout: "dAppAuth", auth: true },
    component: () => import("../views/AppAuth.vue"),
  },
  {
    path: "/signup",
    name: "Registration",
    meta: { layout: "auth", auth: false },
    component: () => import("../views/Registration.vue"),
  },
  {
    path: "/verification/:code",
    name: "verification",
    meta: { layout: "verification", auth: false },
  },
  {
    path: "/auth/password/",
    name: "ForGotPassword",
    meta: { layout: "ForGotPassword", auth: false },
  },
  {
    path: "/new_password/:code",
    name: "NewPassword",
    meta: { layout: "NewPassword", auth: false },
  },
  {
    path: "/auth-token/:code",
    name: "AuthToken",
    meta: { layout: "AuthToken", auth: false },
  },
  {
    path: "/delete-cache/:id",
    name: "Cache",
    meta: { layout: "main", auth: false },
    component: () => import("../views/Cache.vue"),
  },
  {
    path: "/success",
    name: "Success",
    meta: { layout: "payment", auth: false },
    component: () => import("../views/PaymentSuccess.vue"),
  },
  {
    path: "/error",
    name: "Error",
    meta: { layout: "payment", auth: false },
    component: () => import("../views/PaymentError.vue"),
  },
  {
    path: "*/*",
    name: "page not found",
    meta: { layout: "main", auth: false },
    component: () => import("../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function extractLang(to) {
  // 1. Нормальный вариант
  if (to.query.lang) return to.query.lang;

  // 2. GA зашил ?lang=xx внутрь _ga
  if (to.query._ga) {
    try {
      const decoded = decodeURIComponent(to.query._ga);
      const match = decoded.match(/[?&]lang=([a-z]{2})/i);
      if (match) return match[1];
    } catch (e) {
      return null;
    }
  }

  return null;
}

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("w_token");
  const requireAuth = to.matched.some((r) => r.meta.auth);
  const urlParams = new URLSearchParams(window.location.search);

  const query = { ...to.query };

  const lang = extractLang(to);

  if (lang) {
    i18n.locale = lang;
    query.lang = lang;
    localStorage.setItem("language", lang);
  }

  // 1. Проверка авторизации
  if (requireAuth && !token) {
    return next({
      path: "/login",
      query: {
        ...query, // 🔥 сохраняем lang
        ...(query.app ? { app: 1 } : {}),
        ...(!query.app ? { message: "login" } : {}),
      },
    });
  }

  // 2. Проверка onboard_finish
  // const onboardFinish = store.state.key.user.onboard_finished; // true/false

  // if (requireAuth && onboardFinish === false && to.path !== "/welcome") {
  //   return next("/welcome");
  // }

  // 3. Если пришли с ?app=1 → ставим флаг
  if (urlParams.get("app")) {
    localStorage.setItem("app_web_auth", 1);
  }

  next();
});

export default router;
